export { ClickAndCollectInfoModal } from './ClickAndCollectInfoModal'
